import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";

const API_ENDPOINT = API_URL + "api/v1";

export const getAutomationList = (params = {}) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  
  // Default params for sorting by runs (highest first) and grouping by active status
  const defaultParams = {
    orderBy: "metrics.totalRuns",
    isAscending: false
  
  };
  
  // Merge default params with any custom params passed in
  const mergedParams = { ...defaultParams, ...params };
  
  return axios.get(`${API_ENDPOINT}/automate`, {
    headers: obj,
    params: mergedParams
  });
};

export const getAllIntegration = (params: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/integration`, {
    headers: obj,
    params: params,
  });
};

export const deleteAutomation = (id: string) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.delete(`${API_ENDPOINT}/automate/${id}`, { headers: obj });
};

export const getFilePageContent = (params: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/content`, {
    headers: obj,
    params: params,
  });
};

export const getLeadList = (params: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/lead-list`, {
    headers: obj,
    params: params,
  });
};

export const getUserOrganizationList = (params: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/user/employee`, {
    headers: obj,
    params: params,
  });
};

export const createAutomation = (data: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.post(`${API_ENDPOINT}/automate`, data, { headers: obj });
};
export const postUserIntigration = (data: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.post(`${API_ENDPOINT}/integration/user-integration`, data, {
    headers: obj,
  });
};

export const updateAutomation = (id: string, data: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.put(`${API_ENDPOINT}/automate/${id}`, data, { headers: obj });
};

export const setManuallyAutomate = (data: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.post(`${API_ENDPOINT}/automate/set-manually`, data, {
    headers: obj,
  });
};


export const getAutomationById = (id: string, params = {}) => {
 let obj = {
   ...getHeaderOptions,
   Authorization: localStorage.getItem("auth_token") || "",
 };
 
 const defaultParams = {
   orderBy: "_id",
   isAscending: false,
   page: 1,
   perPage: 15
 };
 
 const mergedParams = { ...defaultParams, ...params };
 
 return axios.get(`${API_ENDPOINT}/automate/${id}`, {
   headers: obj,
   params: mergedParams
 });
};